import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/auth/AuthProvider";

export default function AdminNav() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const pathname = location.pathname;

  const [timeLeftMs, setTimeLeftMs] = useState<number | null>(null);

  useEffect(() => {
    let t: any = null;
    function update() {
      if (!user || !user.expiresAt) {
        setTimeLeftMs(null);
        return;
      }
      const left = Math.max(0, user.expiresAt - Date.now());
      setTimeLeftMs(left);
    }
    update();
    t = setInterval(update, 1000);
    return () => clearInterval(t);
  }, [user]);

  function formatMs(ms: number | null) {
    if (ms == null) return "";
    const total = Math.floor(ms / 1000);
    if (total <= 0) return "expired";
    const hrs = Math.floor(total / 3600);
    const mins = Math.floor((total % 3600) / 60);
    const secs = total % 60;
    if (hrs > 0) return `${hrs}h ${mins}m ${secs}s`;
    if (mins > 0) return `${mins}m ${secs}s`;
    return `${secs}s`;
  }

  // Only show on admin-related pages (also show on dashboard for quick access)
  const showOn = ["/admin", "/queue", "/dashboard", "/admin/blacklist"];
  const visible = !!user && showOn.some((p) => pathname.startsWith(p));
  if (!visible) return null;

  return (
    <div className="bg-card border-b">
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <Button asChild variant="ghost" size="sm">
            <Link to="/dashboard">Dashboard</Link>
          </Button>
          <Button asChild variant="ghost" size="sm">
            <Link to="/admin">All Submissions</Link>
          </Button>
          <Button asChild variant="ghost" size="sm">
            <Link to="/admin/blacklist">Blacklist</Link>
          </Button>
          <Button asChild variant="ghost" size="sm">
            <Link to="/queue">Queue</Link>
          </Button>
        </div>
        <div className="flex items-center gap-2">
          {user?.name && (
            <div className="text-sm text-muted-foreground">Signed in as {user.name}</div>
          )}
          {timeLeftMs != null && (
            <div className="text-sm text-muted-foreground">Expires in {formatMs(timeLeftMs)}</div>
          )}
          <Button variant="outline" size="sm" onClick={() => logout()}>
            Sign out
          </Button>
        </div>
      </div>
    </div>
  );
}
